<template>
  <div>
    <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
      <div class="card" v-if="wohnung && bauprojekt_logo">
        <div class="card-header">
          <h6>{{ wohnung.name }} | {{ wohnung.haus.name }} | {{ wohnung.haus.haus_bp.name }}</h6>
        </div>
        <div class="card-body">         
          <div class="flex-column-ul">
            <ul>
              <li><strong>Wohnfläche:</strong> {{ wohnung.wohnflaeche }} m<sup>2</sup></li>
              <li><strong>Stockwerk:</strong> {{ wohnung.etage }}</li>
              <li v-if="kaufpreis_json_computed">
                <strong>Preis:</strong> {{ kaufpreis_json_computed }}
                <feather type="chevron-down" class="infra-blue pointer icon-button button-top-down" @click="showKaufpreisDetails"></feather>
                <div id="show_preis" v-if="show.kaufpreis_json">
                  <div v-if="wohnung.kaufpreis_json.length">
                    <div v-for="(prop, index) in wohnung.kaufpreis_json" :key="'prop_' + index">
                      <div class="priceCon">
                        <div>{{ prop.bezeichnung }}</div>
                        <div class="infra-blue">{{ displayCurrency(prop.preis.toFixed(2).replace(".", ",")) }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    Keine Preise eingetragen.
                  </div>
                </div>
              </li>
              <li v-if="wohnung.haus.stell_preis">Stellplatz: {{ displayCurrency(wohnung.haus.stell_preis) }}</li>
              <li v-if="wohnung.haus.tgstell_preis">TG-Stellplatz: {{ displayCurrency(wohnung.haus.tgstell_preis) }}</li>
            </ul>
            <ul>
              <li v-if="wohnung.kurzbeschreibung.length"><p><strong>Kurzbeschreibung:</strong></p> {{wohnung.kurzbeschreibung}} </li>
              <li v-if="wohnung.besonderheiten.length > 3"><p><strong>Besonderheiten:</strong></p> {{wohnung.besonderheiten}} </li>
            </ul>
          </div>
        </div>
        <!-- Modals Start -->
        <b-modal id="showDetail" ok-only size="lg">
          <div>
            <div class="details-container blog-box blog-list row details-container">
              <div class="bauprojekt-image col-sm-5 img-fit" v-if="bauprojekt_logo">
                <img :src="bauprojekt_logo.full_url" />
              </div>
              <div class="col-sm-7">
                <div class="blog-details">
                  <div>
                    <div><h6>Bauprojekt</h6></div>
                    <div>{{ wohnung.haus.haus_bp.name }}</div>
                    <div>Strasse: {{ wohnung.haus.haus_bp.strasse ? wohnung.haus.haus_bp.strasse : "nicht hinterlegt" }}</div>
                    <div>Ort: {{ wohnung.haus.haus_bp.ort ? wohnung.haus.haus_bp.ort : "nicht hinterlegt" }}</div>
                  </div>
                  <div style="margin-top:10px;">
                    <div><h6>Haus</h6></div>
                    <div>{{ wohnung.haus.name }}</div>
                    <div>Stellplatz Preis: {{ wohnung.haus.stell_preis }}€</div>
                    <div>TG Stellplatz Preis: {{ wohnung.haus.tgstell_preis }}€</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template slot="modal-header">
            <h4>übergreifende Projektinformationen</h4>
          </template>
        </b-modal>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KundeProjektInfos",
  props: ["wohnung_id"],
  data() {
    return {
      wohnung: false,
      bauprojekt_logo: false,
      show: {
        kaufpreis_json: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      toasts: "app/toasts",
      wohnungen: "app/wohnungen",
      kuwo: "app/kuwo",
    }),
    kaufpreis_json_computed() {
      if (this.wohnung.kaufpreis_json == null) return 0;
      let result = 0;
      this.wohnung.kaufpreis_json.forEach((price) => {
        console.log(price);
        result = parseFloat(result) + parseFloat(price.preis);
      });

      return this.displayCurrency(
        parseFloat(result)
          .toFixed(2)
          .replace(".", ",")
      );
    },
  },
  async created() {
    if (!this.wohnung) this.wohnung = this.kuwo.find((w) => w.id == this.$route.params.wohnung_id);
    if (!this.bauprojekt_logo) this.bauprojekt_logo = await this.fetchAsset(this.wohnung.haus.haus_bp.logo);
  },
  methods: {
    showKaufpreisDetails() {
      this.show.kaufpreis_json = this.show.kaufpreis_json ? false : true;
    },
    showDetailModal() {
      this.$bvModal.show("showDetail");
    },
    async fetchAsset(id) {
      try {
        const response = this.$store.dispatch("app/getAsset", id);
        return response;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Projektbilder.", this.toasts.failure);
      }
    },
  },
};
</script>

<style>
#show_preis {
  border-bottom: 2px solid #004f7d;
  width:350px;
}

.center {
  display: block;
  margin: auto;
}

.button-top-down {
  vertical-align: middle;
}

.priceCon {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.priceCon div:first-of-type {
  width: 70%;
}

.info-item div {
  display: inline-block;
}

.info-container img,
.details-container img {
  max-width: 100%;
}

.info-container {
  display: flex;
  flex-flow: column;
}

.flex-column-ul {
  display:flex;
  justify-content:flex-start;
}

.flex-column-ul {
  margin:10px;
}

.flex-column-ul ul:first-of-type {
  width:60%
}
</style>
